<div class="full-overlay tc-white flex flex-col justify-center items-center">
  <bv-card class="block-card">
    <bv-card-header>
      <bv-card-title>{{ title }}</bv-card-title>
    </bv-card-header>
    <bv-card-body>
      <p>
        {{ message }}
      </p>
    </bv-card-body>
  </bv-card>
</div>
